module.exports = __webpack_public_path__ + "res/7-img_game_bg_q_t.97ba6c077265ed7380dcefb2a9747160.png";